import { render } from "./ContinuouslyExchangeCards.vue?vue&type=template&id=247636fc&ts=true"
import script from "./ContinuouslyExchangeCards.vue?vue&type=script&lang=ts"
export * from "./ContinuouslyExchangeCards.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__